import { Checkbox } from 'rsuite';


export const CustomCheckBox = ({ ...rest }) => {
  return (
    <Checkbox
      {...rest}
      className="custom-checkbox"
    />
  );
}
